import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import LogPage from "../components/LogPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
		firm: state.data.userInfo.firm,
		rank: state.data.userInfo.rank,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const LogPageContainer = connect(mapStateToProps, mapDispatchToProps)(LogPage);

export default LogPageContainer;


// WEBPACK FOOTER //
// ./src/containers/LogPageContainer.js